import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import { AutoAckConstant, MessageRole, MessageType, OriginConstant } from '../constants';
import { getProtocolVersion, createPostMessage } from '../utils/protocol';
import { isFunction } from '../utils/is';
import { getAckId, getAckMeta } from '../utils/ack';
import { SyncHook } from '../utils/hooks';
import { requestIframeLog } from '../utils/logger';
import { MessageContextStage } from './channel';

/**
 * Message handler function type
 */

/**
 * Message type matcher
 * - string: exact match message type
 * - RegExp: regex match message type
 * - function: custom match function
 */

/**
 * Protocol version validator function
 * @param version protocol version in message
 * @returns true if version is compatible, false otherwise
 */

/**
 * Message handler registration options
 */

/**
 * Message handler entry
 */

/**
 * MessageDispatcher - Message dispatcher for client/server interaction
 * 
 * Responsibilities:
 * - Using MessageChannel for receiving and sending messages
 * - Dispatching received messages to registered handlers
 * - Managing handler registration/unregistration
 * - Protocol version validation
 * 
 * This is the high-level interface used by client and server implementations.
 * It works with transport-agnostic MessageContext instead of transport-specific MessageEvent.
 */
export class MessageDispatcher {
  constructor(channel, role, instanceId) {
    _defineProperty(this, "hooks", {
      inbound: new SyncHook(),
      beforeSend: new SyncHook(),
      afterSend: new SyncHook(),
      sendError: new SyncHook()
    });
    _defineProperty(this, "autoAckMaxMetaLength", AutoAckConstant.MAX_META_LENGTH);
    _defineProperty(this, "autoAckMaxIdLength", AutoAckConstant.MAX_ID_LENGTH);
    _defineProperty(this, "fallbackTargetOrigin", OriginConstant.ANY);
    /** Message handler list */
    _defineProperty(this, "handlers", []);
    /** Reference count (for determining if can be destroyed when cached) */
    _defineProperty(this, "refCount", 0);
    this.channel = channel;
    this.secretKey = channel.secretKey;
    this.type = channel.type;
    this.role = role;
    this.instanceId = instanceId;

    // Create bound receiver callback
    this.boundReceiver = (data, context) => {
      this.dispatchMessage(data, context);
    };

    // Add receiver callback to handle incoming messages
    this.channel.addReceiver(this.boundReceiver);
  }

  /**
   * Set fallback target for outgoing auto-ack messages.
   */
  setFallbackTarget(targetWindow, targetOrigin = OriginConstant.ANY) {
    this.fallbackTargetWindow = targetWindow;
    this.fallbackTargetOrigin = targetOrigin;
  }

  /**
   * Configure auto-ack echo limits (advanced/internal).
   *
   * @internal
   */
  setAutoAckLimits(limits) {
    if (!limits || typeof limits !== 'object') return;
    if (typeof limits.maxMetaLength === 'number' && Number.isFinite(limits.maxMetaLength) && limits.maxMetaLength >= 0) {
      this.autoAckMaxMetaLength = limits.maxMetaLength;
    }
    if (typeof limits.maxIdLength === 'number' && Number.isFinite(limits.maxIdLength) && limits.maxIdLength >= 0) {
      this.autoAckMaxIdLength = limits.maxIdLength;
    }
  }

  // ==================== Reference Counting ====================

  /**
   * Increment reference count
   */
  addRef() {
    this.refCount++;
  }

  /**
   * Decrement reference count
   * @returns current reference count
   */
  release() {
    return --this.refCount;
  }

  /**
   * Get reference count
   */
  getRefCount() {
    return this.refCount;
  }

  // ==================== Message Handling ====================

  /**
   * Register message handler
   * @param matcher message type matcher
   * @param handler handler function
   * @param options registration options (priority, version validation, etc.)
   * @returns function to unregister
   */
  registerHandler(matcher, handler, options) {
    var _opts$priority;
    var opts = typeof options === 'number' ? {
      priority: options
    } : options || {};
    var entry = {
      matcher,
      handler,
      priority: (_opts$priority = opts.priority) !== null && _opts$priority !== void 0 ? _opts$priority : 0,
      versionValidator: opts.versionValidator,
      onVersionError: opts.onVersionError
    };
    this.handlers.push(entry);
    // Sort by priority in descending order
    this.handlers.sort((a, b) => b.priority - a.priority);
    return () => {
      var index = this.handlers.indexOf(entry);
      if (index >= 0) {
        this.handlers.splice(index, 1);
      }
    };
  }

  /**
   * Unregister message handler
   */
  unregisterHandler(handler) {
    var index = this.handlers.findIndex(entry => entry.handler === handler);
    if (index >= 0) {
      this.handlers.splice(index, 1);
    }
  }

  /**
   * Dispatch message to matching handlers
   */
  dispatchMessage(data, context) {
    // If message has already been handled by another dispatcher, skip processing
    if (context.handledBy) {
      return;
    }

    // Role-based message filtering: only process messages from the opposite role
    // - Server only processes messages from client (role === 'client')
    // - Client only processes messages from server (role === 'server')
    if (data.role !== undefined) {
      var expectedRole = this.role === MessageRole.CLIENT ? MessageRole.SERVER : MessageRole.CLIENT;
      if (data.role !== expectedRole) {
        // Message is from the same role, ignore it to prevent routing confusion
        return;
      }
    }
    var offEarlyAutoAck;
    try {
      this.hooks.inbound.call(data, context);
      var _type = data.type;
      var _version = getProtocolVersion(data);

      /**
       * Auto-ack state for this incoming message.
       *
       * Design notes:
       * - We only auto-ack after the message is truly handled (context.handledBy is set)
       *   AND accepted (context.acceptedBy is set).
       * - This prevents incorrectly acknowledging messages when there is no pending consumer.
       */
      var autoAckState = {
        sent: false
      };
      var maybeAutoAck = () => {
        if (autoAckState.sent) return;
        if (!context.handledBy) return;
        if (!context.acceptedBy) return;
        autoAckState.sent = true;
        this.tryAutoAck(data, context);
      };

      /**
       * Early auto-ack: send ACK as soon as the handler "accepts" the message.
       *
       * Why:
       * - For request delivery confirmation, ACK should represent "accepted/claimed by server"
       *   instead of "handler finished".
       * - This keeps client-side ackTimeout meaningful and avoids being delayed by business logic.
       *
       * Notes:
       * - Only contexts created by MessageChannel have onStateChange; tests may provide mocks.
       * - We keep the original end-of-dispatch maybeAutoAck() as a fallback for older/edge contexts.
       */
      var onStateChangeMaybe = context.onStateChange;
      offEarlyAutoAck = typeof onStateChangeMaybe === 'function' ? onStateChangeMaybe('autoAck:early', (_prev, next) => {
        if (next === MessageContextStage.ACCEPTED) {
          maybeAutoAck();
        }
      }) : undefined;
      var _iterator = _createForOfIteratorHelper(this.handlers),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var entry = _step.value;
          if (this.matchType(_type, entry.matcher)) {
            // If message has been handled by a previous handler, stop processing
            if (context.handledBy) {
              break;
            }

            // If handler specified version validation
            if (entry.versionValidator && _version !== undefined) {
              if (!entry.versionValidator(_version)) {
                var _entry$onVersionError;
                // Version incompatible, call error handler (if any)
                (_entry$onVersionError = entry.onVersionError) === null || _entry$onVersionError === void 0 || _entry$onVersionError.call(entry, data, context, _version);
                continue; // Skip this handler, try other handlers
              }
            }
            try {
              entry.handler(data, context);
              // After handler execution, check if it marked the message as handled
              // If context.handledBy is set by the handler, subsequent handlers will be skipped
            } catch (e) {
              // Ignore handler exception, continue executing other handlers
              requestIframeLog('error', 'Handler error', e);
            } finally {
              // Auto-ack once the message is accepted + handled.
              maybeAutoAck();
            }
          }
        }

        // Fallback: if a handler accepted+handled without throwing, ensure we auto-ack.
        // (This is safe due to autoAckState guard.)
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      maybeAutoAck();
    } finally {
      try {
        var _offEarlyAutoAck;
        (_offEarlyAutoAck = offEarlyAutoAck) === null || _offEarlyAutoAck === void 0 || _offEarlyAutoAck();
      } catch (_unused) {
        // ignore
      }
      /**
       * Mark as "done" only when this dispatcher actually claimed/handled this message.
       * - If the message was never claimed (handledBy not set), we keep `doneBy` empty so another
       *   dispatcher/handler still has a chance to process it.
       */
      if (context.handledBy) {
        context.markDoneBy(context.handledBy);
      }
    }
  }

  /**
   * Auto-ack logic (generalized requireAck workflow)
   *
   * Notes:
   * - This is intentionally conservative: it only runs after the message is marked as handled
   *   (via `context.handledBy`) to avoid acknowledging messages that no consumer will process.
   * - For backward compatibility:
   *   - REQUEST defaults to requiring ACK unless `requireAck === false`
   *   - Other message types only ack when `requireAck === true`
   */
  tryAutoAck(data, context) {
    var _context$source;
    var targetWindow = (_context$source = context.source) !== null && _context$source !== void 0 ? _context$source : this.fallbackTargetWindow;
    if (!targetWindow) return;
    var targetOrigin = context.source ? context.origin : this.fallbackTargetOrigin || context.origin;
    var type = data.type;

    // Don't auto-ack ack messages (avoid loops)
    if (type === MessageType.ACK) return;

    /**
     * ACK-only requireAck workflow (no compatibility guarantees):
     * - For any message with `requireAck === true`, once the message is accepted/handled
     *   (via `context.acceptedBy` + `context.handledBy`),
     *   we reply with `ack`.
     *
     * This unifies:
     * - request delivery confirmation
     * - response receipt confirmation
     * - stream frame delivery confirmation (e.g. stream_data per-frame ack)
     */
    if (data.requireAck === true && !!context.acceptedBy) {
      var ack = this.getAutoAckEchoPayload(data.ack);
      this.sendMessage(targetWindow, targetOrigin, MessageType.ACK, data.requestId, {
        path: data.path,
        targetId: data.creatorId,
        ack
      });
    }
  }

  /**
   * Limit echoed ack payload size for auto-ack replies.
   *
   * We only echo a fixed shape `{ id, meta?: string }`:
   * - If meta is too long, we drop meta and only echo `{ id }`.
   * - If id is missing or too long, omit `ack` field.
   */
  getAutoAckEchoPayload(rawAck) {
    if (rawAck === undefined) return undefined;
    var id = getAckId(rawAck);
    if (id === undefined) return undefined;
    if (typeof id === 'string' && id.length > this.autoAckMaxIdLength) return undefined;
    var meta = getAckMeta(rawAck);
    if (meta === undefined) return {
      id
    };
    if (meta.length > this.autoAckMaxMetaLength) return {
      id
    };
    return {
      id,
      meta
    };
  }

  /**
   * Check if message type matches
   */
  matchType(type, matcher) {
    if (typeof matcher === 'string') {
      return type === matcher;
    }
    if (matcher instanceof RegExp) {
      return matcher.test(type);
    }
    if (isFunction(matcher)) {
      return matcher(type);
    }
    return false;
  }

  // ==================== Sending (Delegated to Channel) ====================

  /**
   * Send raw message to target window
   * @param target target window
   * @param message message data (already formatted as PostMessageData)
   * @param targetOrigin target origin (defaults to '*')
   */
  send(target, message, targetOrigin = OriginConstant.ANY) {
    // Automatically set role and creatorId if not already set (for backward compatibility)
    if (message.role === undefined) {
      message.role = this.role;
    }
    if (message.creatorId === undefined && this.instanceId) {
      message.creatorId = this.instanceId;
    }
    this.hooks.beforeSend.call(target, targetOrigin, message);
    try {
      var _ok = this.channel.send(target, message, targetOrigin);
      this.hooks.afterSend.call(target, targetOrigin, message, _ok);
      return _ok;
    } catch (e) {
      this.hooks.sendError.call(target, targetOrigin, message, e);
      throw e;
    }
  }

  /**
   * Send typed message to target window (creates PostMessageData automatically)
   * @param target target window
   * @param targetOrigin target origin
   * @param type message type
   * @param requestId request ID
   * @param data additional data
   */
  sendMessage(target, targetOrigin, type, requestId, data) {
    // Automatically set role, creatorId, and secretKey based on dispatcher's properties
    // Create message with role, creatorId, and secretKey using createPostMessage directly
    var message = createPostMessage(type, requestId, _objectSpread(_objectSpread({}, data), {}, {
      role: this.role,
      creatorId: this.instanceId,
      secretKey: this.secretKey
    }));
    return this.send(target, message, targetOrigin);
  }

  // ==================== Utilities ====================

  /**
   * Add path prefix
   */
  prefixPath(path) {
    return this.channel.prefixPath(path);
  }

  /**
   * Get the underlying message channel
   */
  getChannel() {
    return this.channel;
  }

  /**
   * Destroy dispatcher (clear handlers, but don't destroy channel as it may be shared)
   */
  destroy() {
    this.handlers.length = 0;
    this.channel.removeReceiver(this.boundReceiver);
  }
}